import { adaptMapBounds, getMapMarkers, mapMap } from 'src/common/stores/adapters/bex-api/search/map-adapter';
import { SearchMigrationAdapter } from 'src/common/stores/adapters/bex-api';

import { HotelResultsViewModel } from 'models';

import { OperationResult } from '__generated__/api/api-operations';
import { PropertyMapMigration } from '__generated__/api';

export const adaptMap: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertyMapMigration.Query>
): HotelResultsViewModel => {
  const { data } = bexApiResults;
  const { propertySearch } = data;

  if (!propertySearch || !propertySearch.map) {
    return bffResults;
  }

  return {
    ...bffResults,
    map: mapMap(data)
  };
};

export const adaptStaticMapSrc: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertyMapMigration.Query>
): HotelResultsViewModel => {
  const { data } = bexApiResults;
  const { propertySearch } = data;

  if (!propertySearch || !propertySearch.map || !propertySearch.map.staticMapSrc) {
    return bffResults;
  }

  return {
    ...bffResults,
    map: {
      ...bffResults.map,
      staticMapSrc: propertySearch.map.staticMapSrc
    }
  };
};

export const adaptMapBoundsAndCenter: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertyMapMigration.Query>
): HotelResultsViewModel => {
  const { data } = bexApiResults;
  const { propertySearch } = data;

  if (!propertySearch || !propertySearch.map) {
    return bffResults;
  }

  const { map } = propertySearch;

  return {
    ...bffResults,
    map: {
      ...bffResults.map,
      title: map.title,
      ...adaptMapBounds(data)
    }
  };
};

export const adaptMapMarkersAndSheets: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertyMapMigration.Query>
): HotelResultsViewModel => {
  const { data } = bexApiResults;
  const { propertySearch } = data;
  const spinnerMap = propertySearch && propertySearch.map;
  const bffMap = bffResults && bffResults.map;

  if (!spinnerMap || !bffMap) {
    return bffResults;
  }

  const myMarkers = getMapMarkers(data);

  return {
    ...bffResults,
    map: {
      ...bffMap,
      markers: myMarkers
      // title: bffMap.title ? bffMap.title : null,
      // zoom: bffMap.zoom ? bffMap.zoom : null,
      // center: bffMap.center ? bffMap.center : null,
      // bounds: bffMap.bounds ? bffMap.bounds : null,
      // staticMapSrc: bffMap.staticMapSrc ? bffMap.staticMapSrc : null,
      // showSearchButton: bffMap.showSearchButton ? bffMap.showSearchButton : null,
      // searchMessage: bffMap.searchMessage ? bffMap.searchMessage : null,
      // filterDisplayOptions: bffMap.filterDisplayOptions ? bffMap.filterDisplayOptions : null,
      // messagingModel: bffMap.messagingModel ? bffMap.messagingModel : null,
      // filters: bffMap.filters ? bffMap.filters : null
    }
  };
};
